import { render } from "./RegisterBusinessAddress.vue?vue&type=template&id=2ba5e188"
import script from "./RegisterBusinessAddress.vue?vue&type=script&lang=js"
export * from "./RegisterBusinessAddress.vue?vue&type=script&lang=js"

import "./RegisterBusinessAddress.vue?vue&type=style&index=0&id=2ba5e188&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__